<template>
  <el-checkbox :disabled="isReadOnly" type="checkbox" :checked="isChecked" @change="onChange">
    {{ label }}
  </el-checkbox>
</template>
<script>
/**
 * @class Checkbox
 *
 * @description This component renders a checkbox input
 */
export default {
  name: 'base-input',
  inheritAttrs: false,
  props: ['name', 'label', 'checked', 'value', 'readOnly'],
  data() {
    return {
      isChecked: false,
    }
  },
  methods: {
    onChange($event) {
      this.isChecked = !this.isChecked
      this.$emit('form-item-changed', {
        name: this.name,
        value: this.isChecked,
      })
      //this.$emit('change', $event)
    },
  },
  created() {
    if (this.checked) {
      this.isChecked = !!this.checked
    } else {
      switch (this.value) {
        case 1:
          this.isChecked = true
          break
        default:
          this.isChecked = false
          break
      }
    }
  },
  computed: {
    isReadOnly() {
      if (this.readOnly === 1 || this.readOnly === true || this.readOnly === '1') {
        return true
      } else {
        return false
      }
    },
  },
  watch: {
    value(newValue) {
      this.$emit('form-item-changed', { name: this.name, value: newValue })
    },
  },
}
</script>
<style scoped>
[disabled] {
  cursor:
    url('../../../assets/img/notallowed24.png') 2 2,
    not-allowed !important;
}
.checkbox[disabled] label {
  opacity: 0.65;
  cursor:
    url('../../../assets/img/notallowed24.png') 2 2,
    not-allowed !important;
}
</style>
